export const EDITOR_DRAFT_COMMON_TOOLBAR_OPTIONS = [
  "inline",
  "blockType",
  "fontSize",
  // "fontFamily",
  "list",
  "textAlign",
  "colorPicker",
  "link",
  "embedded",
  // "emoji",
  "image",
  // "remove",
  "history",
]
